import { render, staticRenderFns } from "./MakeNotes.vue?vue&type=template&id=8d4cbf1a&scoped=true&"
import script from "./MakeNotes.vue?vue&type=script&lang=js&"
export * from "./MakeNotes.vue?vue&type=script&lang=js&"
import style0 from "./MakeNotes.vue?vue&type=style&index=0&id=8d4cbf1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4cbf1a",
  null
  
)

export default component.exports